import axios from 'axios';
import { config } from '../shared/app.config';
import store from '../store/store';

const RESOURCE_NAME = '/webadmin/restaurants';
const RESOURCE_NAME_PUBLIC = '/webadmin/public/restaurants';
const RESOURCE_REPORT = '/app/reports'

export default {
    getAll(language) {
        if (!language) language = store.getters.getCurrentLanguage;
        const requestConfig = {
            headers: {
                // eslint-disable-next-line sonarjs/no-duplicate-string
                'Content-Type': 'multipart/form-data',
                'X-localization': language,
            },
        };
        return axios.get(config.webApiBase + RESOURCE_NAME, requestConfig);
    },
    getOne(id, language) {
        if (!language) language = store.getters.getCurrentLanguage;
        const requestConfig = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-localization': language,
            },
        };
        return axios.get(`${config.webApiBase + RESOURCE_NAME}/${id}`, requestConfig);
    },
    getOnePublic(slug, language) {
        if (!language) language = store.getters.getCurrentLanguagePublic;
        const requestConfig = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-localization': language,
            },
        };
        return axios.get(`${config.webApiBase + RESOURCE_NAME_PUBLIC}/${slug}`, requestConfig);
    },
    getAllForSelect(language) {
        if (!language) language = store.getters.getCurrentLanguage;
        const requestConfig = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-localization': language,
            },
        };
        return axios.get(`${config.webApiBase + RESOURCE_NAME}/select-restaurants`, requestConfig);
    },
    getAllByUser(language) {
        if (!language) language = store.getters.getCurrentLanguage;
        const requestConfig = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-localization': language,
            },
        };
        return axios.get(`${config.webApiBase + RESOURCE_NAME}/user`, requestConfig);
    },
    getAllTypesForSelect(language) {
        if (!language) language = store.getters.getCurrentLanguage;
        const requestConfig = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-localization': language,
            },
        };
        return axios.get(`${config.webApiBase + RESOURCE_NAME}/types`, requestConfig);
    },
    getAllProfilesForSelect(language) {
        if (!language) language = store.getters.getCurrentLanguage;
        const requestConfig = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-localization': language,
            },
        };
        return axios.get(`${config.webApiBase + RESOURCE_NAME}/profiles`, requestConfig);
    },
    getAllLanguagesForSelect(language) {
        if (!language) {
            language = config.defaultLocale;
        }
        const requestConfig = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-localization': language,
            },
        };
        return axios.get(`${config.webApiBase + RESOURCE_NAME}/languages`, requestConfig);
    },
    create(restaurant, language) {
        if (!language) language = store.getters.getCurrentLanguage;
        const requestConfig = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-localization': language,
            },
        };

        return axios.post(config.webApiBase + RESOURCE_NAME, restaurant, requestConfig);
    },
    edit(id, restaurant, language) {
        if (!language) language = store.getters.getCurrentLanguage;
        const requestConfig = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-localization': language,
            },
        };
        restaurant.model = 'put';
        return axios.post(`${config.webApiBase + RESOURCE_NAME}/${id}`, restaurant, requestConfig);
    },
    calculateCoordinates(country, address, postalCode) {
        return axios.post(`${config.webApiBase + RESOURCE_NAME}/coordinates`, {
            country,
            address,
            postalCode,
        });
    },

    downloadReport(id, language) {
        if (!language) language = store.getters.getCurrentLanguage;
        const requestConfig = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-localization': language,
            },
        };
        return axios.get(`${config.webApiBase + RESOURCE_REPORT}/${id}`, requestConfig, { responseType: 'text' })
    },

    submitInfo(formData) {

        return axios.post(`${config.webApiBase + RESOURCE_NAME}/loyalty`, formData)

    }
};